import type { PluginClientModule } from "../../plugin-types";
import { manifest } from "../manifest";
import { createPluginRoutes } from "./routes";
import { pluginSidebar } from "./sidebar";

export const client: PluginClientModule = {
	manifest,
	createRoutes: createPluginRoutes,
	sidebar: pluginSidebar,
};
